import ReactGA from 'react-ga4';

const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

// Initialize GA4 (only if measurement ID is configured)
export const initGA = () => {
  if (GA_MEASUREMENT_ID) {
    ReactGA.initialize(GA_MEASUREMENT_ID, {
      testMode: false,
    });
    console.log('Google Analytics initialized');
  } else {
    console.log('Google Analytics disabled (no measurement ID configured)');
  }
};

// Track page views
export const trackPageView = (path: string, title?: string) => {
  if (GA_MEASUREMENT_ID) {
    ReactGA.send({ hitType: 'pageview', page: path, title });
  }
};

// Track custom events
export const trackEvent = (
  eventName: string,
  eventParams?: {
    category?: string;
    action?: string;
    label?: string;
    value?: number;
    [key: string]: any;
  }
) => {
  if (GA_MEASUREMENT_ID) {
    ReactGA.event(eventName, eventParams);
  }
};

// Specific event tracking functions
export const analytics = {
  // Onboarding events
  trackSaaSOnboardingCompleted: (userId?: string) => {
    trackEvent('saas_onboarding_completed', {
      category: 'Onboarding',
      action: 'Completed',
      label: 'SaaS',
      user_id: userId,
    });
  },
  
  trackHotelOnboardingCompleted: (userId?: string) => {
    trackEvent('hotel_onboarding_completed', {
      category: 'Onboarding',
      action: 'Completed',
      label: 'Hotel',
      user_id: userId,
    });
  },
  
  // Integration events
  trackHotelConnectionRequest: (hotelId: string, saasId: string) => {
    trackEvent('hotel_connection_request', {
      category: 'Integration',
      action: 'Request',
      hotel_id: hotelId,
      saas_id: saasId,
    });
  },
  
  trackHotelConnectionAccepted: (hotelId: string, saasId: string) => {
    trackEvent('hotel_connection_accepted', {
      category: 'Integration',
      action: 'Accepted',
      hotel_id: hotelId,
      saas_id: saasId,
    });
  },
};
